import Http from "http";

export default class HttpError extends Error {
  code: number;
  reportToSentry: boolean;

  constructor(code: number, message?: string, options?: { reportToSentry?: boolean }) {
    super(message ?? Http.STATUS_CODES[code]);
    this.code = code;
    this.reportToSentry = options?.reportToSentry ?? true;
  }
}
